import Request from 'yow/request.js';

export default class {
	constructor(options) {
		this.url = 'http://98.128.130.94:3000';
//		this.url = 'http://localhost:3000';
	}

	async fetch(sql) {
		try {
			let request = new Request(this.url);
			let query = {};

			query.sql = sql;

			console.log(`Query: ${query.sql}`);

            console.log(`Connecting to /mysql on ${this.url}`);
			let result = await request.get('/mysql', {query: query});

			return result.body;
		} catch (error) {
            console.log(`Failed to connect to ${this.url}`)
			throw error;
		}
	}

	async sql(sql) {
		try {
			let request = new Request(this.url);
			let query = {};

			query.sql = sql;

			console.log(`SQL: ${query.sql}`);

			let result = await request.get('/mysql', {query: query});

			return result.body;
		} catch (error) {
			throw error;
		}
	}
}
